import React from 'react';
export function Header() {
  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }
  };
  return <header className="sticky top-0 z-50 w-full border-b border-border bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60" data-id="element-77">
      <div className="container max-w-7xl mx-auto px-4" data-id="element-78">
        <div className="flex h-16 items-center justify-between" data-id="element-79">
          {/* Logo - 25% larger (h-10 → h-12) */}
          <div className="flex items-center" data-id="element-80">
            <img src="https://cdn.magicpatterns.com/uploads/3a5J6De2WuRis18d4fBZJq/wisepilot-dark.svg" alt="WisePilot" className="h-12 w-auto" data-id="element-81" />
          </div>

          {/* Navigation */}
          <nav className="hidden md:flex items-center space-x-6 text-sm font-medium" aria-label="Main navigation" data-id="element-82">
            <button onClick={() => scrollToSection('system')} className="text-muted-foreground hover:text-foreground transition-colors" data-id="element-83">
              The System
            </button>
            <button onClick={() => scrollToSection('how-it-outperforms')} className="text-muted-foreground hover:text-foreground transition-colors" data-id="element-84">
              Performance
            </button>
            <button onClick={() => scrollToSection('integrations')} className="text-muted-foreground hover:text-foreground transition-colors" data-id="element-85">
              Integrations
            </button>
            <a href="#" className="inline-flex items-center justify-center rounded-lg px-4 py-2 text-sm font-semibold text-white bg-[hsl(var(--brand-blue-light))] hover:bg-[hsl(216,71%,40%)] dark:bg-[hsl(var(--brand-blue-dark))] dark:hover:bg-[hsl(214,100%,65%)] transition-colors" data-id="element-86">
              Book a Demo
            </a>
          </nav>

          {/* Mobile menu button */}
          <button className="md:hidden text-foreground" aria-label="Open menu" data-id="element-87">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-88">
              <line x1="4" x2="20" y1="12" y2="12" data-id="element-89" />
              <line x1="4" x2="20" y1="6" y2="6" data-id="element-90" />
              <line x1="4" x2="20" y1="18" y2="18" data-id="element-91" />
            </svg>
          </button>
        </div>
      </div>
    </header>;
}